import React from 'react';

import { NavItem } from './NavItem';
import { INavItem } from './Navigation';

interface NavProps {
  items: INavItem[];
  openedTree: string;
  pathname: string;
  setOpenedTree: (tree: string) => void;
}

export const Nav: React.FC<NavProps> = ({ items, openedTree, pathname, setOpenedTree }) => (
  <ul data-test-id="nav-container" className="zoom-nav">
    {items.map((item) => (
      <NavItem item={item} key={item.url} openedTree={openedTree} pathname={pathname} onClick={setOpenedTree} />
    ))}
  </ul>
);
